import { NgModule } from '@angular/core'
import { PreloadAllModules, RouterModule, Routes } from '@angular/router'

const routes: Routes = [
  {
    path: '',
    redirectTo: 'home',
    pathMatch: 'full',
  },
  {
    path: 'profilepage',
    loadChildren: () =>
      import('./profilepage/profilepage.module').then(
        (m) => m.ProfilepagePageModule
      ),
  },
  {
    path: 'aboutpage',
    loadChildren: () =>
      import('./aboutpage/aboutpage.module').then((m) => m.AboutpagePageModule),
  },
  {
    path: 'faqpage',
    loadChildren: () =>
      import('./faqpage/faqpage.module').then((m) => m.FaqpagePageModule),
  },
  {
    path: 'searchpage',
    loadChildren: () =>
      import('./searchpage/searchpage.module').then(
        (m) => m.SearchpagePageModule
      ),
  },
  {
    path: 'default-page',
    loadChildren: () =>
      import('./default-page/default-page.module').then(
        (m) => m.DefaultPagePageModule
      ),
  },
  {
    path: 'contact-page',
    loadChildren: () =>
      import('./contact-page/contact-page.module').then(
        (m) => m.ContactPagePageModule
      ),
  },
  {
    path: 'province-page',
    loadChildren: () =>
      import('./province-page/province-page.module').then(
        (m) => m.ProvincePagePageModule
      ),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('./admin/admin.module').then((m) => m.AdminPageModule),
  },
  {
    path: 'forgot-login',
    loadChildren: () =>
      import('./forgot-login/forgot-login.module').then(
        (m) => m.ForgotLoginPageModule
      ),
  },
  {
    path: 'loged-in',
    loadChildren: () =>
      import('./loged-in/loged-in.module').then((m) => m.LogedInPageModule),
  },
  {
    path: 'service-page',
    loadChildren: () =>
      import('./service-page/service-page.module').then(
        (m) => m.ServicePagePageModule
      ),
  },
  {
    path: 'user-page',
    loadChildren: () =>
      import('./user-page/user-page.module').then((m) => m.UserPagePageModule),
  },
  {
    path: 'assisted-service',
    loadChildren: () =>
      import('./assisted-service/assisted-service.module').then(
        (m) => m.AssistedServicePageModule
      ),
  },
  {
    path: 'servicespage',
    loadChildren: () =>
      import('./servicespage/servicespage.module').then(
        (m) => m.ServicespagePageModule
      ),
  },
  {
    path: 'servicespage/:profileId',
    loadChildren: () =>
      import('./servicespage/servicespage.module').then(
        (m) => m.ServicespagePageModule
      ),
  },
  {
    path: 'review-page',
    loadChildren: () =>
      import('./review-page/review-page.module').then(
        (m) => m.ReviewPagePageModule
      ),
  },
  {
    path: 'review-page/:jobId',
    loadChildren: () =>
      import('./review-page/review-page.module').then(
        (m) => m.ReviewPagePageModule
      ),
  },
  {
    path: 'franchise-opportunity',
    loadChildren: () =>
      import('./franchise-opportunity/franchise-opportunity.module').then(
        (m) => m.FranchiseOpportunityPageModule
      ),
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./home/home.module').then((m) => m.HomePageModule),
  },
  {
    path: 'overview',
    loadChildren: () =>
      import('./consulting/overview/overview.module').then(
        (m) => m.OverviewPageModule
      ),
  },
  {
    path: 'services',
    loadChildren: () =>
      import('./consulting/services/services.module').then(
        (m) => m.ServicesPageModule
      ),
  },
  {
    path: 'portfolio',
    loadChildren: () =>
      import('./consulting/portfolio/portfolio.module').then(
        (m) => m.PortfolioPageModule
      ),
  },
  {
    path: 'hire',
    loadChildren: () =>
      import('./consulting/hire/hire.module').then((m) => m.HirePageModule),
  },
  {
    path: 'aboutHomePage',
    redirectTo: 'home#aboutHomePage',
    pathMatch: 'full',
  },
  {
    path: 'faqHomePage',
    redirectTo: 'home#faqHomePage',
    pathMatch: 'full',
  },
  {
    path: 'servicesHomePage/:id',
    redirectTo: 'home#:id',
    pathMatch: 'full',
  },
  {
    path: 'contactHomePage',
    redirectTo: 'home#contactHomePage',
    pathMatch: 'full',
  },
]

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      onSameUrlNavigation: 'reload',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
